import { CheckCircleFilled, CloseCircleFilled } from "@ant-design/icons";
import { roundOff } from "src/utils/helperFunctions";
import { TrustScorePill } from "src/components/Common/TrustScore";
import PassChip from "./Report40/PassChip";

export const getTraitsWithCutoffScores = (reportData) => {
  const traits = [];
  (reportData?.buckets ?? []).forEach((bucket) => {
    Object.values(bucket?.traitsMeta ?? {}).forEach((trait) => {
      if (trait.cutOff != null && typeof trait.cutOff === "number" && trait.cutOff >= 0) {
        traits.push({
          name: trait.displayName,
          cutoff: trait.cutOff,
          score: trait.score,
        });
      }
    });
  });
  if (reportData?.fitScore?.cutOff != null) {
    traits.push({
      name: "Overall",
      cutoff: reportData.fitScore.cutOff,
      score: reportData.fitScore.score,
    });
  }
  return traits;
};

// soft: the web report's 4.0 chips (V2); the PDF keeps the pills.
const CutoffTraitsTable = ({ reportData, soft = false }) => {
  const traits = getTraitsWithCutoffScores(reportData);

  if (!traits.length) return null;

  return (
    <div className="cutoff-traits-table">
      <div className="cutoff-traits-row cutoff-traits-header">
        <span>Skill Name</span>
        <span>Cutoff</span>
        <span>Score</span>
        <span>Result</span>
      </div>
      {traits.map((trait, idx) => {
        const passed = trait.score >= trait.cutoff;
        return (
          <div key={idx} className={`cutoff-traits-row${trait.name === "Overall" ? " cutoff-traits-row--overall" : ""}`}>
            <span>{trait.name}</span>
            <span>{trait.cutoff}</span>
            <span>{roundOff(trait.score)}</span>
            {soft ? <PassChip status={passed ? "PASS" : "FAIL"} title={`${roundOff(trait.score)} against a cut-off of ${trait.cutoff}`} /> : <TrustScorePill
              icon={passed ? <CheckCircleFilled style={{ color: "#2C6740", fontSize: 16 }} /> : <CloseCircleFilled style={{ color: "#ff5267", fontSize: 16 }} />}
              text={passed ? "PASS" : "FAIL"}
              bg={"transparent"}
              color={passed ? "#2C6740" : "#ff5267"}
              tooltipText={""}
              className={"height-26 width-80"}
            />}
          </div>
        );
      })}
    </div>
  );
};

export default CutoffTraitsTable;
